import { render, staticRenderFns } from "./FinanceIncome.vue?vue&type=template&id=1616f620&scoped=true&"
import script from "./FinanceIncome.vue?vue&type=script&lang=js&"
export * from "./FinanceIncome.vue?vue&type=script&lang=js&"
import style0 from "./FinanceIncome.vue?vue&type=style&index=0&id=1616f620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1616f620",
  null
  
)

export default component.exports